<template>
    <div class="landing-page-introduction-box" v-if="!logged_in_user.isACP || logged_in_user.isStaff">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="title">
            <div>
                Supporting our Commercial Partners
            </div>
        </div>
        <div class="main _image-right">
            <div class="image">
                <img src="/images/commercial-why-join-acp-header.jpg">
            </div>
            <div class="content">
                <div>
                    <p>
                        Fabricators and installers are at the heart of every successful ACP project. That’s why this section has been shaped around the resources you actually need - with access to live commercial leads, regional monthly market updates, branding and sales support materials, merchandise, PR, upcoming training courses and more.
                    </p>
                    <p>
                        This resource centre is your one‑stop destination for everything related to your Partner status and your relationship with Epwin Window Systems.
                    </p>
                    <p>
                        <img src="/images/acp-icons.jpg">
                    </p>
                    <p v-if="!logged_in_user.isStaff">
                        To find out more about becoming an Approved Commercial Manufacturer, please contact
                        us by clicking 'Make Enquiry' below.
                    </p>
                    <div class="footer" v-if="!logged_in_user.isStaff">
                        <div class="enquiry-button">
                            <div class="btn-primary" @click.stop="enquiry_box_open = true">
                                Make Enquiry
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Have question or want to join the ACP scheme?</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'logged_in_user',
    ],
    data() {
      return {
        'enquiry_box_open': false,
        'enquiry_message': 'I would like more information on signing up for the ACP scheme',
        sending: false,
      }
    },
    methods: {
      sendEnquiry() {
        this.enquiry_box_open = false;
        this.sending = true;
        axios.post('/enquiry/send', {
          'enquiry_type_id': 21,
          'message': this.enquiry_message,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'Join ACP scheme enquiry',
            'value': 'Join ACP scheme enquiry',
          });

          this.sending = false;
          Swal.fire({
            title: 'Enquiry Sent',
            icon: 'success',
            text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
    },
  };
</script>
